import { configureStore } from "@reduxjs/toolkit";
import modalSlice from "../Slices/modalSlice";
import settingsSlice from "../Slices/settingsSlice";
import gameSettingsSlice from "../Slices/gameSettingsSlice";
import assetsSlice from "../Slices/assetsSlice";
import soundsSlice from "../Slices/soundsSlice";
import spinSlice from "../Slices/spinSlice";
import animationsSlice from "../Slices/animationsSlice";
import freeSpinsSlice from "../Slices/freeSpinsSlice";
export const store = configureStore({
  reducer: {
    modal: modalSlice,
    settings: settingsSlice,
    game: gameSettingsSlice,
    assets: assetsSlice,
    sound: soundsSlice,
    spin: spinSlice,
    animations: animationsSlice,
    freeSpins: freeSpinsSlice,
  },
});
